import styles from "./snbchart.module.scss";

export default function Snbchart({ extraData, getHighlightedText }) {
  const values = extraData["Patient Values"];
  return (
    <div className={styles.wrap}>
      <table className={styles.table}>
        <tbody>
          {/*Labels*/}
          <tr>
            <td
              className={styles.cell}
              data-id="demo_label"
            >
              <span data-id="container-break">
                {getHighlightedText("", "demo_label")}
              </span>
            </td>
            <td
              className={styles.headCell}
              data-id={"mean_label"}
            >
              <span data-id="container-break">
                {getHighlightedText("Mean", "mean_label")}
              </span>
            </td>
            <td
              className={styles.headCell}
              data-id={"patient_label"}
            >
              <span data-id="container-break">
                {getHighlightedText("Patient", "patient_label")}
              </span>
            </td>
          </tr>
          {/*SNA*/}
          <tr className={styles.shadedRow}>
            <td
              className={styles.headCell}
              data-id="sna_label"
            >
              <span data-id="container-break">
                {getHighlightedText("SNA", "sna_label")}
              </span>
            </td>
            <td
              className={styles.valueCell}
              data-id={"sna_mean"}
            >
              <span data-id="container-break">
                {getHighlightedText("81°", "sna_mean")}
              </span>
            </td>
            <td
              className={styles.valueCell}
              data-id={"sna_patient"}
            >
              <span data-id="container-break">
                {getHighlightedText(`${values["SNA"]}`, "sna_patient")}
              </span>
            </td>
          </tr>
          {/*SNB*/}
          <tr>
            <td
              className={styles.headCell}
              data-id="snb_label"
            >
              <span data-id="container-break">
                {getHighlightedText("SNB", "snb_label")}
              </span>
            </td>
            <td
              className={styles.valueCell}
              data-id={"snb_mean"}
            >
              <span data-id="container-break">
                {getHighlightedText("79°", "snb_mean")}
              </span>
            </td>
            <td
              className={styles.valueCell}
              data-id={"snb_patient"}
            >
              <span data-id="container-break">
                {getHighlightedText(`${values["SNB"]}`, "snb_patient")}
              </span>
            </td>
          </tr>
          {/*Sella-Nasion to Mandibular Plane*/}
          <tr className={styles.shadedRow}>
            <td
              className={styles.headCell}
              data-id="sntmp_label"
            >
              <span data-id="container-break">
                {getHighlightedText(
                  "Sella-Nasion to Mandibular Plane",
                  "sntmp_label"
                )}
              </span>
            </td>
            <td
              className={styles.valueCell}
              data-id={"sntmp_mean"}
            >
              <span data-id="container-break">
                {getHighlightedText("32°", "sntmp_mean")}
              </span>
            </td>
            <td
              className={styles.valueCell}
              data-id={"sntmp_patient"}
            >
              <span data-id="container-break">
                {getHighlightedText(`${values["SN-MP"]}`, "sntmp_patient")}
              </span>
            </td>
          </tr>
          {/*Frankfort horizontal to mandibular plane*/}
          <tr>
            <td
              className={styles.headCell}
              data-id="fhtmp_label"
            >
              <span data-id="container-break">
                {getHighlightedText(
                  "Frankfort horizontal to mandibular plane",
                  "fhtmp_label"
                )}
              </span>
            </td>
            <td
              className={styles.valueCell}
              data-id={"fhtmp_mean"}
            >
              <span data-id="container-break">
                {getHighlightedText("24°", "fhtmp_mean")}
              </span>
            </td>
            <td
              className={styles.valueCell}
              data-id={"fhtmp_patient"}
            >
              <span data-id="container-break">
                {getHighlightedText(`${values["FMA"]}`, "fhtmp_patient")}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
